import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"
import moment  from "moment-timezone";

const IST_TIMEZONE = "Asia/Kolkata";

export const MomentformatTime=(date:any,  format = "DD MMM YYYY")=>{
  if (!date) return "";
  return moment(date).tz(IST_TIMEZONE).format(format);
};

export const getISTStartDate = (date:any) => {
    const now = moment().tz(IST_TIMEZONE);
    const selected = moment.tz(date, IST_TIMEZONE);

    if (selected.isSame(now, "day")) {
        return now.toDate(); // current time
    }

    return selected.startOf("day").toDate(); // future date
};
export const getISTEndOfDay = (date:any) => moment.tz(date, IST_TIMEZONE).endOf("day").toDate();


export const formatUTCToIST = (
  utcDate,
  format = "DD MMM YYYY, hh:mm A"
) => {
  if (!utcDate) return "";

  return moment
    .utc(utcDate)
    .tz(IST_TIMEZONE)
    .format(format);
};

export const formatDateAndTime = (
  date:any,
  format = "DD MMM YYYY, hh:mm A"
) => {
  if (!date) return "";
  return moment(date).format(format);
};


export const getDaysLeftFromTodayIST = (utcDate) => {
  if (!utcDate) return 0;

  return moment
    .utc(utcDate)
    .tz(IST_TIMEZONE)
    .startOf("day")
    .diff(moment().tz(IST_TIMEZONE).startOf("day"), "days");
};

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export const formatTime = (time: string) => {
  const [hours, minutes] = time.split(':');
  const hour = parseInt(hours);
  const ampm = hour >= 12 ? 'PM' : 'AM';
  const displayHour = hour === 0 ? 12 : hour > 12 ? hour - 12 : hour;
  return `${displayHour}:${minutes} ${ampm}`;
};


export const  getSlotTimeRange=(slots:any)=> {
  if (!slots || slots.length === 0) return "";

  // Sort by start_time to ensure correct order
  const sorted = [...slots].sort((a, b) => {
    const [aHour, aMin] = a.start_time.split(":").map(Number);
    const [bHour, bMin] = b.start_time.split(":").map(Number);
    return aHour * 60 + aMin - (bHour * 60 + bMin);
  });

  const firstSlot = sorted[0];
  const lastSlot = sorted[sorted.length - 1];

  // // Convert 24-hour time (HH:mm) to 12-hour format with AM/PM
  // const formatTime = (timeStr:any) => {
  //   let [hour, minute] = timeStr.split(":").map(Number);
  //   const ampm = hour >= 12 ? "PM" : "AM";
  //   hour = hour % 12 || 12; // Convert 0 or 12 -> 12
  //   return `${hour}:${minute.toString().padStart(2, "0")}${ampm}`;
  // };

  return `${formatTime(firstSlot.start_time)} - ${formatTime(lastSlot.end_time)}`;
}

export const getPriceWithInr = (value: string | number) => {
  return `₹${value}`
}

export const createFormData = (payload) => {
  const formData = new FormData();

  Object.keys(payload).forEach((key) => {
      if (payload[key] !== undefined && payload[key] !== null) {
          formData.append(key, payload[key]);
      }
  });

  return formData;
};

export const scrollToTop = () => {
  window.scrollTo({ top: 0, behavior: 'smooth' });
};


export const generateGoogleMapUrl = (lat: number, lng: number) => {
  // return `https://www.google.com/maps?q=${lat},${lng}`;
  return  `https://www.google.com/maps/dir/?api=1&destination=${lat},${lng}`
};


export const getUserLocation = () => {
  return new Promise((resolve, reject) => {
    if (!navigator.geolocation) {
      reject("Geolocation not supported");
      return;
    }

    navigator.geolocation.getCurrentPosition(
      (position) => {
        resolve({
          lat: position.coords.latitude,
          lng: position.coords.longitude
        });
      },
      (error) => {
        reject(error.message);
      },
      {
        enableHighAccuracy: true,
        timeout: 10000,
        maximumAge: 0
      }
    );
  });
};


export const isValidMobile = (mobile:any) => {
  if (!mobile) return false;

  // Remove spaces & dashes
  const cleaned = mobile.replace(/[\s-]/g, "");

  // Indian numbers: +91 optional, starts with 6-9, total 10 digits
  const mobileRegex = /^(?:\+91)?[6-9]\d{9}$/;

  return mobileRegex.test(cleaned);
};


export  function getTimeLeftFromISO(
  isoDateString: string,
  returnRawSeconds = false
): number {
  const targetDate = new Date(isoDateString);
  if (isNaN(targetDate.getTime())) {
    throw new Error('Invalid ISO date string provided');
  }

  const now = new Date();
  const diffMs = targetDate.getTime() - now.getTime();
  const diffSec = Math.floor(diffMs / 1000);

  return returnRawSeconds ? diffSec : Math.max(0, diffSec);
}


export const getMinutesLeft = (expiryTime:any) => {
    const now = new Date() as any;
    const expiry = new Date(expiryTime) as any;

    const diffMs = expiry - now; // difference in milliseconds

    if (diffMs <= 0) return 0; // already expired

    return Math.floor(diffMs / (1000 * 60)); // convert to minutes
};
